import { useId } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/cn';

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  hint?: string;
  options: Array<{ value: string | number; label: string }>;
}

export const Select = ({ label, error, hint, options, className, ...props }: SelectProps) => {
  const id = useId();

  return (
    <div className="flex flex-col gap-1.5">
      {label && (
        <label htmlFor={id} className="text-label font-medium text-neutral">
          {label}
        </label>
      )}
      <div className="relative">
        <select
          id={id}
          className={cn(
            'w-full appearance-none rounded-control border bg-surface py-2.5 pl-3 pr-9 text-body text-ink transition-colors hover:border-brand disabled:cursor-not-allowed disabled:bg-page disabled:text-muted',
            error ? 'border-bad' : 'border-line-strong',
            className
          )}
          {...props}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <ChevronDown size={16} className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-muted" aria-hidden />
      </div>
      {error && <span className="text-label text-bad">{error}</span>}
      {hint && !error && <span className="text-label text-muted">{hint}</span>}
    </div>
  );
};
